import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import './styles.scss';

import CustomerService from 'services/customer.service';
import { ICustomer } from 'models/Customer';
import { Button } from '../../Button';
import Text from '../../Text';
import AutoComplete from 'components/AutoComplete';
import Input from 'components/Input';
import AutoCompleteCompanyModel from 'components/AutoComplete/Company';
import searchImg from 'img/search-icon.svg';
import SwitchComponent from 'components/SwitchComponent';

const SearchHeader: React.FC<any> = (props) => {
  const customer = useSelector(
    (state: { customer: ICustomer; }) => state.customer
  );
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const customerMaxResults = 20;
  const customerService = new CustomerService();
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const { hide, closeDropdown } = props;

  function onSelectAutoCompleteOption(item: any) {
    customerService.findById(item.id).then((result: any) => {
      const { data } = result;
      dispatch({ type: 'SET_CUSTOMER', data });
      setSelectedCustomer(data.companyName);
      setShowAutoComplete(false);
      if (closeDropdown) closeDropdown();
    });
  }

  function onDiscardSelectedCustomer() {
    dispatch({ type: 'SET_CUSTOMER', data: {} });
    setSelectedCustomer('');
    location.pathname === '/dashboard'
      ? document.location.reload()
      : navigate('/cotacoes-dashboard');
  }

  function customerNameClick() {
    if (closeDropdown) closeDropdown();
    navigate('/cliente');
  }

  function searchMask(value: string) {
    return value.replace(
      /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/g,
      '$1.$2.$3/$4-$5'
    );
  }

  function handleOnBlur(id?: string) {
    const exceptionButtonAutoCompleteId = 'auto-complete-header';
    if (id === exceptionButtonAutoCompleteId) return;
    
    setShowAutoComplete(false);
  }

  return (
    <>
      {!(hide && customer?.companyName) && (
        <SwitchComponent
          roles={['administrator', 'member']}
          type={['employee']}
        >
          <AutoComplete
            show={showAutoComplete}
            request={(value: any) =>
              customerService.autoComplete(value.toLowerCase())
            }
            onSelect={(data: any) => onSelectAutoCompleteOption(data)}
            content={AutoCompleteCompanyModel}
            maxResults={customerMaxResults}
            hide={hide}
          >
            <Input
              placeholder="Busca de clientes"
              onChange={(e: any) => setSelectedCustomer(e.target.value)}
              onFocus={() => setShowAutoComplete(true)}
              onBlur={(e) => handleOnBlur(e.relatedTarget?.id)}
              name="Cliente"
              className="w-100"
              type="text"
              icon={searchImg}
              value={searchMask(selectedCustomer)}
            />
          </AutoComplete>
        </SwitchComponent>
      )}

      {customer?.companyName && (
        <div className={`animated fadeIn header-selected-company-box ${!hide ? 'ml-3' : ''} p-1 d-flex align-center`}>
          <Button
            className="overflow-x-hidden"
            onClick={customerNameClick}
            width="auto"
          >
            <Text size={14} className="mr-2 color-blue-gray">
              {customer.companyName}
            </Text>
          </Button>
          <Button
            className="rounded-full bg-primary"
            onClick={onDiscardSelectedCustomer}
            style={{ width: 19, height: 19 }}
          >
            <Text className="color-white font-bold">&times;</Text>
          </Button>
        </div>
      )}
    </>
  );
};

export default SearchHeader;
